export const translations = {
  en: {
    nav: {
      home: "Home",
      reels: "Reels",
      profile: "Profile",
    },
    browse: {
      title: "Browse",
      hint: "Choose a country to browse. Pick your app language below.",
      language: "Language",
      country: "Country",
      close: "Close",
    },
    home: {
      searchPlaceholder: "Search profiles",
      selectCountry: "Select browse country",
      selectCountryWithName: "Select browse country ({{country}})",
      viewModeLabel: "View mode",
      mapView: "Map view",
      gridView: "Card view",
      noProfiles: "No profiles match your filters.",
    },
    filter: {
      title: "Filter",
      reset: "Reset",
      region: "Region",
      category: "Category",
      services: "Services",
      nearby: "Nearby ({{km}} km)",
      distance: "Distance",
      city: "City",
      allCities: "All cities",
      showProfiles: "Show {{count}} profiles",
      showProfile: "Show {{count}} profile",
      close: "Close filters",
    },
    profile: {
      years: "years",
      verified: "Verified",
    },
    languages: {
      en: "English",
      de: "German",
      es: "Spanish",
      fr: "French",
    },
  },
  de: {
    nav: {
      home: "Start",
      reels: "Reels",
      profile: "Profil",
    },
    browse: {
      title: "Entdecken",
      hint: "Wähle ein Land. Stelle die App-Sprache unten ein.",
      language: "Sprache",
      country: "Land",
      close: "Schließen",
    },
    home: {
      searchPlaceholder: "Profile suchen",
      selectCountry: "Land auswählen",
      selectCountryWithName: "Land auswählen ({{country}})",
      viewModeLabel: "Ansicht",
      mapView: "Kartenansicht",
      gridView: "Rasteransicht",
      noProfiles: "Keine Profile entsprechen deinen Filtern.",
    },
    filter: {
      title: "Filter",
      reset: "Zurücksetzen",
      region: "Region",
      category: "Kategorie",
      services: "Angebot",
      nearby: "In der Nähe ({{km}} km)",
      distance: "Entfernung",
      city: "Stadt",
      allCities: "Alle Städte",
      showProfiles: "{{count}} Profile anzeigen",
      showProfile: "{{count}} Profil anzeigen",
      close: "Filter schließen",
    },
    profile: {
      years: "Jahre",
      verified: "Verifiziert",
    },
    languages: {
      en: "Englisch",
      de: "Deutsch",
      es: "Spanisch",
      fr: "Französisch",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      reels: "Reels",
      profile: "Perfil",
    },
    browse: {
      title: "Explorar",
      hint: "Elige un país. Cambia el idioma de la app abajo.",
      language: "Idioma",
      country: "País",
      close: "Cerrar",
    },
    home: {
      searchPlaceholder: "Buscar perfiles",
      selectCountry: "Seleccionar país",
      selectCountryWithName: "Seleccionar país ({{country}})",
      viewModeLabel: "Modo de vista",
      mapView: "Vista mapa",
      gridView: "Vista tarjetas",
      noProfiles: "Ningún perfil coincide con tus filtros.",
    },
    filter: {
      title: "Filtros",
      reset: "Restablecer",
      region: "Región",
      category: "Categoría",
      services: "Servicios",
      nearby: "Cerca ({{km}} km)",
      distance: "Distancia",
      city: "Ciudad",
      allCities: "Todas las ciudades",
      showProfiles: "Mostrar {{count}} perfiles",
      showProfile: "Mostrar {{count}} perfil",
      close: "Cerrar filtros",
    },
    profile: {
      years: "años",
      verified: "Verificado",
    },
    languages: {
      en: "Inglés",
      de: "Alemán",
      es: "Español",
      fr: "Francés",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      reels: "Reels",
      profile: "Profil",
    },
    browse: {
      title: "Explorer",
      hint: "Choisissez un pays. Changez la langue de l'app ci-dessous.",
      language: "Langue",
      country: "Pays",
      close: "Fermer",
    },
    home: {
      searchPlaceholder: "Rechercher des profils",
      selectCountry: "Choisir un pays",
      selectCountryWithName: "Choisir un pays ({{country}})",
      viewModeLabel: "Mode d'affichage",
      mapView: "Vue carte",
      gridView: "Vue cartes",
      noProfiles: "Aucun profil ne correspond à vos filtres.",
    },
    filter: {
      title: "Filtres",
      reset: "Réinitialiser",
      region: "Région",
      category: "Catégorie",
      services: "Services",
      nearby: "À proximité ({{km}} km)",
      distance: "Distance",
      city: "Ville",
      allCities: "Toutes les villes",
      showProfiles: "Afficher {{count}} profils",
      showProfile: "Afficher {{count}} profil",
      close: "Fermer les filtres",
    },
    profile: {
      years: "ans",
      verified: "Vérifié",
    },
    languages: {
      en: "Anglais",
      de: "Allemand",
      es: "Espagnol",
      fr: "Français",
    },
  },
};

export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGE_CODES = ["en", "de", "es", "fr"];

export function normalizeLanguageCode(code) {
  const normalized = String(code || DEFAULT_LANGUAGE).toLowerCase().slice(0, 2);
  return SUPPORTED_LANGUAGE_CODES.includes(normalized) ? normalized : DEFAULT_LANGUAGE;
}

function interpolate(template, vars = {}) {
  return String(template).replace(/\{\{(\w+)\}\}/g, (_, key) => (
    vars[key] != null ? String(vars[key]) : ""
  ));
}

export function translate(language, key, vars) {
  const lang = normalizeLanguageCode(language);
  const parts = key.split(".");
  let node = translations[lang];
  for (const part of parts) {
    node = node?.[part];
  }
  if (node == null) {
    let fallback = translations[DEFAULT_LANGUAGE];
    for (const part of parts) {
      fallback = fallback?.[part];
    }
    node = fallback ?? key;
  }
  return typeof node === "string" ? interpolate(node, vars) : key;
}
